<template>
  <div id="project_single_page">
    <div>{{ $t('required')}}</div>
  </div>
</template>

<script>

import utils from '../../shared/utils'

export default {
  name: 'ProjectSinglePage',
  data () {
    return {
    }
  },
  created () {
    utils.checkLang()
  }
}
</script>

<style scoped>
#project_single_page {
}
</style>
